import React from "react";
import { useSelector } from "react-redux";
import { withSnackbar } from "notistack";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import styles from "./leaderboard.module.scss";

import TopSavingsTableComponent from "./topSavingsTable.component";
import TrandingTechTableComponent from "./trendingTechTable.component";
import HighestRatingTableComponent from "./highestRatingTable.component";
import TopProjectsTableComponent from "./topProjectsTable.component";

const Leaderboard = ({ enqueueSnackbar }) => {
  const {
    councilReducer: { selectedCouncil },
  } = useSelector((state) => state);

  const prepareDataName = (name) => {
    if (name?.length > 12) {
      return (
        <Tooltip placement="bottom" title={`${name}`}>
          <span>{name.slice(0, 12) + " ... "}</span>
        </Tooltip>
      );
    }

    return <span>{name}</span>;
  };

  const prepareLongRow = (tags) => {
    return (
      <Tooltip
        placement="bottom"
        title={`${tags.map((tag) => tag.name).join(", ")}`}
      >
        <span className={styles.moreTagslink}>{" More "}</span>
      </Tooltip>
    );
  };
  const getSortStyles = (sortAttr, table, sortAttrStateValue) => {
    if (table === "topProjects" && sortAttrStateValue === sortAttr) {
      return `${styles.selectedSort}`;
    }
    if (table === "topTrendTechSort" && sortAttrStateValue === sortAttr) {
      return `${styles.selectedSort}`;
    }
    if (table === "topSavings" && sortAttrStateValue === sortAttr) {
      return `${styles.selectedSort}`;
    }
    if (table === "trendProj" && sortAttrStateValue === sortAttr) {
      return `${styles.selectedSort}`;
    }

    return ``;
  };

  const getSortDirectionStytles = (
    sortAttr,
    table,
    sortAttrStateValue,
    sortDirStateValue
  ) => {
    if (table === "topProjects" && sortAttrStateValue === sortAttr) {
      return sortDirStateValue === "asc"
        ? `${styles.selectedAscSort}`
        : `${styles.selectedDescSort}`;
    }
    if (table === "topTrendTechSort" && sortAttrStateValue === sortAttr) {
      return sortDirStateValue === "asc"
        ? `${styles.selectedAscSort}`
        : `${styles.selectedDescSort}`;
    }
    if (table === "topSavings" && sortAttrStateValue === sortAttr) {
      return sortDirStateValue === "asc"
        ? `${styles.selectedAscSort}`
        : `${styles.selectedDescSort}`;
    }
    if (table === "trendProj" && sortAttrStateValue === sortAttr) {
      return sortDirStateValue === "asc"
        ? `${styles.selectedAscSort}`
        : `${styles.selectedDescSort}`;
    }

    return ``;
  };

  return (
    <div className={styles.leaderBoardWrapper}>
      <div className={styles.leaderBoardTitle}>
        {" "}
        <h4>Innovation Leaderboards</h4>
      </div>
      <div className={`row`}>
        <TopProjectsTableComponent
          selectedCouncil={selectedCouncil}
          getSortStyles={getSortStyles}
          getSortDirectionStytles={getSortDirectionStytles}
          prepareDataName={prepareDataName}
          prepareLongRow={prepareLongRow}
          enqueueSnackbar={enqueueSnackbar}
        />

        <TrandingTechTableComponent
          selectedCouncil={selectedCouncil}
          getSortStyles={getSortStyles}
          getSortDirectionStytles={getSortDirectionStytles}
          prepareDataName={prepareDataName}
        />
      </div>
      {/*  */}
      <div className={`row`}>
        <TopSavingsTableComponent
          selectedCouncil={selectedCouncil}
          getSortStyles={getSortStyles}
          getSortDirectionStytles={getSortDirectionStytles}
          prepareDataName={prepareDataName}
        />
        <HighestRatingTableComponent
          selectedCouncil={selectedCouncil}
          getSortStyles={getSortStyles}
          getSortDirectionStytles={getSortDirectionStytles}
          prepareDataName={prepareDataName}
        />
      </div>
    </div>
  );
};

export default React.memo(withSnackbar(Leaderboard));
